import React, { useLayoutEffect } from "react";

export function getAppHeaderTopClass(environment = process.env.REACT_APP_ENV): string {
  return environment === "staging" ? "top-6" : "top-0";
}

export function getAppContentViewportHeightClass(environment = process.env.REACT_APP_ENV): string {
  return environment === "staging"
    ? "h-[calc(100dvh-5.5rem)]"
    : "h-[calc(100dvh-4rem)]";
}

export function getAppContentVisualViewportHeight(environment = process.env.REACT_APP_ENV): string {
  return environment === "staging"
    ? "calc(var(--app-height, 100dvh) - 5.5rem)"
    : "calc(var(--app-height, 100dvh) - 4rem)";
}

export function getAppHeaderSpacerClass(environment = process.env.REACT_APP_ENV): string {
  return environment === "staging" ? "h-[5.5rem]" : "h-16";
}

export function getAppScrollPaddingTopPx(environment = process.env.REACT_APP_ENV): number {
  return environment === "staging" ? 88 : 64;
}

type AppHeaderFrameProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
  maxWidthClassName?: string;
};

export function AppHeaderFrame({ left, right, children, maxWidthClassName = "max-w-4xl" }: AppHeaderFrameProps) {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const previousScrollPaddingTop = root.style.scrollPaddingTop;
    root.style.scrollPaddingTop = `${getAppScrollPaddingTopPx()}px`;

    return () => {
      root.style.scrollPaddingTop = previousScrollPaddingTop;
    };
  }, []);

  return (
    <>
      <header
        data-testid="app-header-frame"
        className={`print:hidden fixed inset-x-0 ${getAppHeaderTopClass()} z-30 box-border h-16 border-b border-[#EADBC8] bg-[#FDF8F5]/95 backdrop-blur-sm`}
      >
        <div
          data-testid="app-header-content"
          className={`mx-auto flex h-full w-full items-center justify-between gap-3 px-4 py-2 sm:px-6 ${maxWidthClassName}`}
        >
          {children ?? (
            <>
              <div className="min-w-0">{left}</div>
              <div className="flex shrink-0 items-center gap-2">{right}</div>
            </>
          )}
        </div>
      </header>
      <div data-testid="app-header-spacer" aria-hidden="true" className={`print:hidden ${getAppHeaderSpacerClass()}`} />
    </>
  );
}
